import React, { createContext, useCallback, useContext, useState } from 'react';
import { DonateByMailModal } from '../components/DonateByMailModal';
type DonateByMailContextValue = {
  openDonateByMail: () => void;
};
const DonateByMailContext = createContext<DonateByMailContextValue | null>(null);
export function DonateByMailProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const openDonateByMail = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return <DonateByMailContext.Provider value={{
    openDonateByMail
  }} data-id="element-399" data-mp="1jfq8k9x5j33c">
      {children}
      <DonateByMailModal isOpen={isOpen} onClose={close} data-id="element-400" data-mp="1emnf01sdjtn5" />
    </DonateByMailContext.Provider>;
}
export function useDonateByMail() {
  const ctx = useContext(DonateByMailContext);
  if (!ctx) {
    throw new Error('useDonateByMail must be used within DonateByMailProvider');
  }
  return ctx;
}